// @ts-nocheck
/* eslint-disable */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cookie',
  template: '',
  imports: [],
})
export class CookieComponent implements OnInit {
  public ngOnInit(): void {
    (function (m, e, t, r, i, k, a): void {
      m[i] =
        m[i] ||
        function (): void {
          (m[i].a = m[i].a || []).push(arguments);
        };
      // @ts-ignore
      m[i].l = 1 * new Date();
      ((k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a));
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    // @ts-ignore
    ym(88111035, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    });
  }
}
